import React from "react";
import styled from "styled-components";
import { useObservedLatency, type LatencyColor } from "../../../../hooks/useObservedLatency";

const colorMap: Record<LatencyColor, string> = {
  green: "#2ecc71",
  yellow: "#f6b93b",
  red: "#e74c3c",
  muted: "#95a5a6",
};

const Wrapper = styled.div`
  position: fixed;
  bottom: 8px;
  right: 12px;
  z-index: 50;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 9px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.85);
  color: #333;
  font-size: 0.72rem;
  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
  border: 1px solid rgba(0, 0, 0, 0.06);
  pointer-events: none;
  user-select: none;
`;

const Dot = styled.span<{ $color: string }>`
  display: inline-block;
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: ${(p) => p.$color};
  box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.6);
`;

const Label = styled.span`
  letter-spacing: 0.02em;
`;

const PingFooter: React.FC = () => {
  const { pingMs, samples, color } = useObservedLatency();
  if (samples === 0) return null;
  return (
    <Wrapper aria-label={`network ping ${pingMs ?? "n/a"}ms`}>
      <Dot $color={colorMap[color]} />
      <Label>{pingMs != null ? `${pingMs}ms` : "—"}</Label>
    </Wrapper>
  );
};

export default PingFooter;
